<template>
  <div>
    <!--    78-->
    <div style="height: 58px">
      <el-col :span="15" :offset="3">
        <div style="float: left">
          <img src="./img/logo.svg"  />
        </div>
        <div style="margin-left: 150px">
          <span style="font-size: 28px;color: #2B78D9;margin-left: -110px;font-weight: bolder">通辽市能碳管理中心</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          <span v-if="account.name">{{account.name}}欢迎您！</span>
          <el-button v-if="!account.name" type="primary" size="small" @click="loginDoor" style="margin-top: 10px">登 录</el-button>
          <el-button v-if="account.name" type="primary" size="small" @click="logOutDoor" style="margin-top: 10px">退 出</el-button>
        </div>
      </el-col>
    </div>
<!--    <Home :permissionInfo="permissionInfo"></Home>-->
<!--    v-if="false"-->
  </div>

</template>

<script>
import axios from 'axios';
// import qs from 'qs';
import * as Setting from "@/setting";
import * as SettingUpdate from "@/settingUpdate";
import {setToken} from "@/setting";
import {setTokenNew} from "@/settingUpdate";

// getPermssion
// import Home from "@/pages/Home/home";
// import { EventBus } from "@/main";
// import urlData from '@/assets/url.json';
// const store = new Vuex.Store({
//   state: {
//     value: '',
//   },
//   mutations: {
//     setValue(state, value) {
//       state.value = value;
//     },
//   },
// });
export default {
  // components: {Home},
  data() {
    return {
      userIP: null,
      // urlData:urlData,
      listfxfk:[
        {name:"园区循环化改造工作台账",url:"http://111.56.142.53:17005/login/oauth/authorize?client_id=e19e65a2a3932dc46ea9&response_type=code&scope=read&redirect_uri=http%3A%2F%2F111.56.142.53%3A10038",permission:"permission_park",year:"2023"},
        {name:"环境基础设施能力台账",url:"http://111.56.142.53:17005/login/oauth/authorize?client_id=2d4dcf4831e2011addb4&response_type=code&scope=read&redirect_uri=http%3A%2F%2F111.56.142.53%3A10039",permission:"permission_environmental",year:"2023"},
        {name:"强制性清洁企业台账",url:"http://111.56.142.53:17005/login/oauth/authorize?client_id=6114d6fd331b9f1a16e9&response_type=code&scope=read&redirect_uri=http%3A%2F%2F111.56.142.53%3A10040",permission:"permission_mandatory",year:"2023"},
        {name:"智能调度平台系统",url:"http://111.56.142.53:17005/login/oauth/authorize?client_id=d00bb59dcf34f751a802&response_type=code&scope=read&redirect_uri=http%3A%2F%2F111.56.142.53%3A10041",permission:"permission_intelligent",year:"2023"},
        {name:"项目调度管理系统",url:"http://111.56.142.53:17005/login/oauth/authorize?client_id=a7f81eac41a5eb8fe6ea&response_type=code&scope=read&redirect_uri=http%3A%2F%2F111.56.142.53%3A10042",permission:"permission_scheduling",year:"2023"},
        {name:"资源节约管理系统",url:"http://10.6.25.38:17003/login/oauth/authorize?client_id=1094f66e01b424750155&response_type=code&scope=read&redirect_uri=http%3A%2F%2F10.6.25.50:10038",permission:"permission_resource",year:"2023"},
        {name:"节能降碳管理系统",url:"http://111.56.142.53:17005/login/oauth/authorize?client_id=fe74d005681f9c2343c3&response_type=code&scope=read&state=zhangmingxing&redirect_uri=http%3A%2F%2F111.56.142.53%3A17002%2Flogin",permission:"permission_fgwOut",year:"2023"},
        {name:"节能降碳管理系统",url:"http://10.6.25.38:17003/login/oauth/authorize?client_id=16a1c43906e86355a2d2&response_type=code&scope=read&state=zhangmingxing&redirect_uri=http%3A%2F%2F10.6.25.39%3A17002%2Flogin",permission:"permission_fgw",year:"2023"}
      ],
      permissionInfo:[],
      casToken:'',
      account:{
        name:'',
        preferred_username:'',
      },
      LogoPic: require("@/assets/image/logo.png"),
      //  参数1
      params: {
        // picCode: "BGPIC",
      },
      //轮播列表
      imgList: [],
      // PICsPACE: localStorage.getItem("picSpace"),
    };
  },
  // create(){
  //   // this.userIP=window.location.href.split('#')[0];
  //   if (localStorage.getItem("accessToken")) {
  //     this.getToken()
  //   }
  //   // this.getToken()
  // },
  created() {
    if (localStorage.getItem("accessToken")) {
      this.getToken()
    }
    // window.location.href.split('#')[0]

    if(this.getSubstringAfterThirdSlash(window.location.href)=='http:10.6.25.39:17001'){
      console.log('Setting.CasdoorSDK', Setting.CasdoorSDK.getSigninUrl());
    }else {
      console.log('SettingUpdate.CasdoorSDK', SettingUpdate.CasdoorSDK.getSigninUrl());
    }
    // console.log('str', str);
  },
  mounted() {
    if (localStorage.getItem("accessToken")) {
      this.getToken()
    }
    // else {
    //   Setting.CasdoorSDK.exchangeForAccessToken().then((res) => {
    //         // let permission={}
    //         this.casToken = res.access_token;
    //         setToken(res.access_token);
    //         // permission=Setting.CasdoorSDK.parseAccessToken(res.access_token);
    //         // this.permissionInfo=permission.payload.permissions
    //         // console.log(Setting.CasdoorSDK.parseAccessToken(res.access_token))
    //         Setting.goToLink("/");
    //     this.getToken()
    //       }
    //   )
    // }
  },
  // beforeDestroy() {
  //   EventBus.$emit('customEvent', { permissionInfo: this.permissionInfo });
  // },
  beforeMount() {
    if(this.getSubstringAfterThirdSlash(window.location.href)=='http:10.6.25.39:17001'){
      Setting.CasdoorSDK.exchangeForAccessToken().then((res) => {
            this.casToken = res.access_token;
            setToken(res.access_token);
            Setting.goToLink("/");
          }
      )
    }else {
          SettingUpdate.CasdoorSDK.exchangeForAccessToken().then((res) => {
            this.casToken = res.access_token;
            setTokenNew(res.access_token);
            SettingUpdate.goToLink("/");
          }
      )
    }
      // Setting.CasdoorSDK.exchangeForAccessToken().then((res) => {
      //   // let permission={}
      //   this.casToken = res.access_token;
      //   setToken(res.access_token);
      //   // permission=Setting.CasdoorSDK.parseAccessToken(res.access_token);
      //   // this.permissionInfo=permission.payload.permissions
      //   // console.log(Setting.CasdoorSDK.parseAccessToken(res.access_token))
      //       Setting.goToLink("/");
      //     }
      // )


  },
  methods: {
    loginDoor(){
      // window.location.href = Setting.CasdoorSDK.getSigninUrl()
      // http://10.6.25.39:17001/
      if(this.getSubstringAfterThirdSlash(window.location.href)=='http:10.6.25.39:17001'){
        Setting.CasdoorSDK.signin_redirect();
      }else {
        // var str=this.getSubstringAfterThirdSlash(Setting.CasdoorSDK.getSigninUrl());
        // window.location.href= Setting.CasdoorSDK.getSigninUrl();
        SettingUpdate.CasdoorSDK.signin_redirect();
        // var str = Setting.CasdoorSDK.getSigninUrl()
        // var num = str.indexOf("n");
        // str = str.substr(num + 1);
        // // str = window.location.href.split('#')[0]+'login'+str;
        // str = 'http://10.8.8.184:17003/login'+str;
        // window.location.href=str;
      }
      // console.log('Setting.CasdoorSDK', Setting.CasdoorSDK.getSigninUrl());
      // window.location.href = Setting.CasdoorSDK.getSigninUrl();
      // console.log('Setting.CasdoorSDK.getSigninUrl();', Setting.CasdoorSDK.getSigninUrl());
      // Setting.CasdoorSDK.signin_redirect();
      // window.location.href = sdk.getSigninUrl()
      // window.location.href = this.getSigninUrl();
    },
    getSubstringAfterThirdSlash(str) {
      const parts = str.split('/');
      if (parts.length > 3) {
        return parts.slice(0, 3).join(''); // 连接前三个部分
      }
      return str; // 如果少于三个'/'，则返回原字符串
    },
    // getSubstringAfterThirdSlash(str) {
    //   var parts = str.split('/');
    //   if (parts.length > 3) {
    //     return parts[3];
    //   }
    //   return null;
    // },
    getToken(){
      if(this.getSubstringAfterThirdSlash(window.location.href)=='http:10.6.25.39:17001'){
        console.log(window.location.href);
        Setting.getUserinfo().then((res) => {
          this.account=res;
          console.log(res);
        });
      }else {
        SettingUpdate.getUserinfo().then((res) => {
          this.account=res;
          console.log(res);
        });
      }
      // if (Setting.isLoggedIn()) {
      //   Setting.getUserinfo().then((res) => {
      //     this.account=res;
      //     console.log(res);
      //   });
      // this.account.name=getPermssion(localStorage.getItem("accessToken")).payload.displayName;
      // this.account.preferred_username=getPermssion(localStorage.getItem("accessToken")).payload.name;
      // if(this.account.name==null){
      //   }
      // }
    },
    logOutDoor(){
      let that =this;
      that.casToken=localStorage.getItem("accessToken");
      // localStorage.removeItem("accessToken");
      that.params.id_token_hint=this.casToken;
      that.params.post_logout_redirect_uri='';
      that.params.state='';
      // console.log('Received name:', getPermssion(localStorage.getItem("accessToken")).payload.name);
      // console.log('Received displayName:', getPermssion(localStorage.getItem("accessToken")).payload.displayName);
      // console.log('Received account.name:', this.account.name);
      // console.log('Received account.preferred_username:', this.account.preferred_username);
      // axios.get("http://10.164.15.31:18000/api/get-permission", {params: {clientId:"d1ddfb2f07102d3afd0f",clientSecret:"559d4dc75c4bb20e0843a0965fd60209cdf23fc4",id:"fgw/permission_fgwOut"}})
      //     .then(function(response) {
      //       console.log(response);
      //     })  http://10.6.25.38:17003  http://10.164.15.31:18000   http://111.56.142.53:17005

      //=============================
      // axios.get('http://10.6.25.38:17003/api/logout', {params: {
      //         // id_token_hint:localStorage.getItem("accessToken"),
      //         id_token_hint:this.casToken,
      //         post_logout_redirect_uri:'',
      //         state:'',
      //         userName:'fgw/'+this.account.preferred_username,
      //     // 'fgw/'+this.account.preferred_username
      //         applicationName:'application_door'
      //     }}).then(res => {
      //   if(res.data.status=='ok'){
      //     // EventBus.$emit('doorEvent', { permissionInfo: this.permissionInfo });
      //     localStorage.removeItem("accessToken");
      //     // sessionStorage.clear();
      //     // localStorage.clear();
      //     Setting.goToLink("/");
      //   }
      //   console.log(res);
      // });
      //==============================
      // Setting.logout();
      // Setting.goToLink("/");
      // // if (Setting.isLoggedIn()) {
      //   Setting.getUserinfo().then((res) => {
      //     this.account=res;
      //     console.log(res)
      //   });
      // // }



      if(this.getSubstringAfterThirdSlash(window.location.href)=='http:10.6.25.39:17001'){
        axios.get('http://10.6.25.38:17003/api/logout', {params: {
            id_token_hint:this.casToken,
            post_logout_redirect_uri:'',
            state:'',
            userName:'fgw/'+this.account.preferred_username,
            // 'fgw/'+this.account.preferred_username
            applicationName:'application_door'
          }}).then(res => {
          if(res.data.status=='ok'){

            axios.get('http://10.6.25.38:17003/api/logout', {params: {
                id_token_hint:this.casToken,
                post_logout_redirect_uri:'',
                state:'',
                userName:'fgw/'+this.account.preferred_username,
                // 'fgw/'+this.account.preferred_username
                applicationName:'application_fgw'
              }}).then(res => {
              if(res.data.status=='ok'){
                localStorage.removeItem("accessToken");
                SettingUpdate.goToLink("/");
              }
              console.log(res);
            });
            // localStorage.removeItem("accessToken");
            // SettingUpdate.goToLink("/");
          }
          console.log(res);
        });
        // axios.get('http://10.6.25.38:17003/api/logout', {params: {
        //     id_token_hint:this.casToken,
        //     post_logout_redirect_uri:'',
        //     state:'',
        //     userName:'fgw/'+this.account.preferred_username,
        //     // 'fgw/'+this.account.preferred_username
        //     applicationName:'application_door'
        //   }}).then(res => {
        //   if(res.data.status=='ok'){
        //     localStorage.removeItem("accessToken");
        //     Setting.goToLink("/");
        //   }
        //   console.log(res);
        // });
      }else {
        // http://10.164.15.31:18000  http://10.8.8.184:17003   http://111.56.142.53:17005  http://10.6.25.38:17003
        // axios.defaults.headers.common[ 'Cache-Control' ] = 'no-cache';
        axios.get('http://10.8.8.184:17003/api/logout', {params: {
            id_token_hint:this.casToken,
            post_logout_redirect_uri:'',
            state:'',
            userName:'fgw/'+this.account.preferred_username,
            // 'fgw/'+this.account.preferred_username
            applicationName:'application_door'
          }}).then(res => {
          if(res.data.status=='ok'){
            // axios.defaults.headers.common[ 'Cache-Control' ] = 'no-cache';
            axios.get('http://10.8.8.184:17003/api/logout', {params: {
                id_token_hint:this.casToken,
                post_logout_redirect_uri:'',
                state:'',
                userName:'fgw/'+this.account.preferred_username,
                // 'fgw/'+this.account.preferred_username
                applicationName:'application_fgw'
              }}).then(res => {
              if(res.data.status=='ok'){
                localStorage.removeItem("accessToken");
                SettingUpdate.goToLink("/");
              }
              console.log(res);
            });
            // localStorage.removeItem("accessToken");
            // SettingUpdate.goToLink("/");
          }
          console.log(res);
        });
      }
    },
    // getAccount(){
    //   // let that =this; get-user-application  get-account clientId:"4dc13c8f1c388bdd0860",clientSecret:"182c7ce7a4068deb45e4ed8e93a1a53240f00c49",
    //   axios.get("http://10.164.15.31:18000/api/get-account", {params: {
    //       clientId:"4dc13c8f1c388bdd0860",clientSecret:"182c7ce7a4068deb45e4ed8e93a1a53240f00c49",
    //       sub:"14decdf1-45a0-4499-8934-c660c7b23756"
    //     }}).then(function(response) {
    //     // that.urlList=response.data.listData;
    //     console.log(response);
    //   })
    // },
  },
  computed: {
    // baseUrl() {
    //   return this.$store.state.fileIp;
    // },
  },

};
</script>

<style lang="less" scoped>
.BackgroundPic {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
}

//banner图的修改
.img-banner {
  // width: 100%;
  // height: 100%;
  object-fit: cover;
}

/deep/ .router-link-active {
  display: block;
  width: 150px;
  background: #dd2126 !important;
}

.topbar {
  width: 100%;
  height: 320px;
  /*background: url(../../assets/image/头部背景.png) no-repeat;*/
  display: flex;
  align-items: flex-end;
  position: relative;
}

a {
  display: inline-block;
  color: white;
  width: 100%;
}

/*.router-link-active{
  background-color: #dd2126;
}*/
.item {
  width: 150px;
  font-size: 22px;
  /*padding: 0 20px;*/
  /*background:rgba(0,0,0,0.7);*/
  cursor: pointer;
  text-align: center;
  line-height: 48px;
  color: white;
}

.item:hover {
  background-color: #dd2126;
}

.top {
  width: 1200px;
  display: flex;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.biaoti {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.biaoti-top {
  position: absolute;
  top: 0;
  width: 100%;
  background: rgba(242, 242, 242, 0.7) !important;
  border-radius: 3px;
  z-index: 1000;
}

.a,
.b {
  height: 20px;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  padding: 8px 0;
  cursor: pointer;
}

.b a {
  height: 20px;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  padding: 0px 0;
  cursor: pointer;
}

.b a:hover {
  color: red;
}

.a:hover {
  color: red;
}

.background-color {
  height: 457px;
}
</style>
